var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wintouch-label"},[_vm._v("\n\t\t"+_vm._s(_vm.item.text)+"\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }